import React, { useState } from "react";
import ReactModal from "react-modal";
import { isMobile, unwrapStyles } from "../utils";
import styled, { ThemeProvider, StyleSheetManager } from "styled-components";
import { FaSearch } from "react-icons/fa";
import "../index.css";
import theme from "../themes";
import SmartSearch from "../components/SmartSearch";
import { Provider } from "react-redux";
import store from "../store";
import { AiFillCloseCircle } from "react-icons/ai";
import root from "react-shadow/styled-components";
import settings from "../settings";
import "../index.css";

const ToggleSmartSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid;
  border-radius: 32px;
  cursor: pointer;
  padding: 10px 0 10px 10px;

  ${({ theme }) => unwrapStyles(theme.toggleSmartSearch)};

  &:after {
    content: "${settings?.components?.toggleSmartSearch?.placeholder}";
  }
  &:hover {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.2s;
    ${({ theme }) => unwrapStyles(theme.toggleSmartSearchHover)};
  }

  ${({ isMobile }) => isMobile && unwrapStyles(theme.toggleSmartSearchMobile)}
`;

const SearchIcon = styled(FaSearch)`
  font-weight: 400;
`;

const CloseModalBtnContainer = styled.div`
  position: fixed;
  margin: auto;
  padding-top: 8px;
  padding-bottom: 10px;
  width: 100%;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AiFillCloseCircleWrapper = styled(AiFillCloseCircle)`
  fill: white;
`;

const SmartSearchWidget = ({ onGameClick }) => {
  const _isMobile = isMobile();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const modalStyles = {
    overlay: {
      position: "fixed",
      zIndex: 3011,
      backgroundColor: "rgba(0,0,0,.4)",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    content: {
      position: "relative",
      inset: "0px",
      maxWidth: _isMobile ? "100%" : "900px",
      maxHeight: _isMobile ? "100%" : "700px",
      width: "100%",
      height: _isMobile ? "100%" : "auto",
      margin: _isMobile ? "0" : "40px 100px",
      padding: _isMobile ? "0" : "20px",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      border: "1px solid #ccc",
      borderRadius: _isMobile ? "0" : "10px",
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <ToggleSmartSearch isMobile={_isMobile} onClick={openModal}>
        <SearchIcon size={22} />
      </ToggleSmartSearch>
      <ReactModal
        contentLabel="Smart Search Modal"
        isOpen={modalIsOpen}
        closeTimeoutMS={15}
        onRequestClose={closeModal}
        className="smart-search-modal"
        style={modalStyles}
      >
        {/*Ensure widget can use styled-components when modal opens, since ReactModal is always rendered directly inside <body> tag. */}
        <StyleSheetManager disableCSSOMInjection>
          <root.div className="shadow-host">
            {_isMobile && (
              <CloseModalBtnContainer onClick={closeModal}>
                <AiFillCloseCircleWrapper size={30} />
              </CloseModalBtnContainer>
            )}
            <SmartSearch onDismiss={closeModal} onGameClick={onGameClick} />
          </root.div>
        </StyleSheetManager>
      </ReactModal>
    </ThemeProvider>
  );
};

export default function SmartSearchWidgetProvider(props) {
  return (
    <Provider store={store}>
      <SmartSearchWidget {...props} />
    </Provider>
  );
}
